/** Backend origin — set REACT_APP_API_BASE at build time (e.g. Vercel env). */
export const API_BASE =
  process.env.REACT_APP_API_BASE || 'http://localhost:8000';
